import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildMushroomCircle: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const ring: [number, number][] = [
        [1, 1],
        [3, 0],
        [5, 1],
        [6, 3],
        [5, 5],
        [3, 6],
        [1, 5],
        [0, 3],
    ];

    ring.forEach(([dx, dz], index) => {
        const height = index % 2 === 0 ? 2 : 1;
        brush.column(dx, dz, 0, height - 1, BLOCK.MushroomStem);
        brush.block(
            dx,
            height,
            dz,
            index % 3 === 0 ? BLOCK.MushroomCapBrown : BLOCK.MushroomCapRed,
        );
    });

    brush.layer(
        2,
        4,
        2,
        4,
        0,
        BLOCK.MushroomCapBrown,
        (x, _y, z) => x !== 3 || z !== 3,
    );
    brush.block(3, 0, 3, BLOCK.Glowstone);
    brush.block(3, 1, 3, BLOCK.MushroomCapRed);
};
